module.exports = __webpack_public_path__ + "static/media/lx-min.0b13819e.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/min/lx-min.svg
// module id = 681
// module chunks = 0